<template>
  <div>
    <div v-if="formStructure !== undefined">
      <div v-if="formStructure.generateElements && formStructure.properties">
        <div
          v-for="(element, index) in formStructure.properties"
          :key="index"
        >
          <q-element-generator
            v-if="formStructure.properties[index].autoGenerate"
            v-model="model"
            :element="formStructure.properties[index]"
          />
        </div>
      </div>
      <div v-if="formStructure.staticFormKey">
        <component
          :is="formStructure.staticFormKey"
          v-model="model"
        />
      </div>
      <q-dialog
        :title="this.$qt('model.deleteDialog.title')"
        width="70%"
        :visible.sync="formDesignerDialogVisible"
      >
        <q-form-designer v-model="formStructure.properties" />
        <span slot="footer">
          <q-button
            type="primary"
          >
            <!--@click=""-->
            {{ $qt('model.deleteDialog.confirm') }}
          </q-button>
          <q-button
            type="inverse"
            @click="formDesignerDialogVisible = false"
          >
            {{ $qt('model.deleteDialog.cancel') }}
          </q-button>
        </span>
      </q-dialog>
    </div>
    <div v-else>
      <h2>Form structure is null</h2>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";

  export default {
    name: "QFormGenerator",

    components: Vue.prototype.$forms,

    props: {
      value: {
        required: true
      },
      formStructure: {
        required: true
      }
    },
    data() {
      return {
        model: {},
        formDesignerDialogVisible: false
      }
    },
    watch: {
      model() {
        this.$emit('input', this.model);
      },
      value() {
        this.model = this.value;
      }
    },
    created() {
      this.model = this.value;
    }

  }
</script>